var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 24.5,
    fill: "#B4AB8F",
    stroke: "#F8F7F6",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_596_10928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5582 34.5798H18.1999C17.9931 34.5798 17.7947 34.4977 17.6484 34.3514C17.5021 34.2051 17.4199 34.0067 17.4199 33.7998V29.4416C17.4196 29.3403 17.4392 29.2399 17.4777 29.1463C17.5162 29.0526 17.5727 28.9674 17.6442 28.8956L29.3442 17.1956C29.4168 17.1219 29.5033 17.0634 29.5987 17.0234C29.6941 16.9835 29.7965 16.9629 29.8999 16.9629C30.0034 16.9629 30.1058 16.9835 30.2012 17.0234C30.2966 17.0634 30.3831 17.1219 30.4557 17.1956L34.8042 21.5441C34.8779 21.6167 34.9364 21.7032 34.9764 21.7986C35.0163 21.894 35.0369 21.9964 35.0369 22.0998C35.0369 22.2033 35.0163 22.3057 34.9764 22.4011C34.9364 22.4965 34.8779 22.583 34.8042 22.6556L23.1042 34.3556C23.0324 34.427 22.9472 34.4836 22.8535 34.5221C22.7598 34.5606 22.6595 34.5802 22.5582 34.5798V34.5798Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.78 19.7598L32.24 25.2198",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_596_10928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.96,
    height: 24.96,
    fill: "white",
    transform: "translate(13.52 13.5195)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEdit);
export default __webpack_public_path__ + "static/media/profile_edit.a8a7c26db3360b7e0ee9fb2c327dbbed.svg";
export { ForwardRef as ReactComponent };